import {
  ALLOCATION_LIST_REQUESTING,
  LIST_ALLOCATIONS_SUCCESS,
  RESET_ALLOCATION_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_ALLOCATION_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case ALLOCATION_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_ALLOCATIONS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.length,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
